// extracted by mini-css-extract-plugin
module.exports = {"row":"VehicleForm-module__row--1ojTX","section":"VehicleForm-module__section--1fdWe"};